import React from 'react';
import './Pages.css';

const Impressum = () => {
  return (
    <div className="page impressum-page">
      <style>{`
        .impressum-page .page-header { background: #008F99; color: #ffffff; }
        .impressum-page .page-title { color: #ffffff; }
        .impressum-page .content-section { background: #ffffff; }
        .impressum-page .content-section .container { text-align: center; }
        .impressum-page .content-section h3 { margin-top: 28px; margin-bottom: 8px; }
        .impressum-page .content-section h3:first-of-type { margin-top: 0; }
      `}</style>
      <section className="page-header">
        <div className="container">
          <div className="page-title">Impressum</div>
        </div>
      </section>
      
      <section className="content-section">
        <div className="container">
          <h3>Angaben gemäß § 5 TMG</h3>
          <p>
            <strong>MINTkitchen KG</strong><br />
            Amselweg 22<br />
            33178 Borchen
          </p>

          <h3>Vertreten durch</h3>
          <p>
            Antonia Schulte
          </p>

          <h3>Kontakt</h3>
          <p>
            <a href="/kontakt">Zum Kontaktformular</a>
          </p>

          <h3>Umsatzsteuer-ID gemäß § 27 a USt-Gesetz</h3>
          <p>
            <strong>DE447714894</strong>
          </p>

          <h3>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
          <p>
            <strong>Antonia Schulte</strong><br />
            Amselweg 22<br />
            33178 Borchen, Deutschland<br />
            Kontakt: <a href="/kontakt">Kontaktformular</a>
          </p>

          <h3>EU-Streitschlichtung</h3>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer"> https://ec.europa.eu/consumers/odr</a>.
            Unsere Kontaktmöglichkeit finden Sie oben im Impressum.
          </p>

          <h3>Verbraucherstreitbeilegung/Universalschlichtungsstelle</h3>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen
            (nach dem Verbraucherstreitbeilegungsgesetz – VSBG).
          </p>

          <h3>Haftung für Inhalte</h3>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
            Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen
            zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung
            oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung
            ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
            Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>

          <h3>Haftung für Links</h3>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
            Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten
            ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
            derartige Links umgehend entfernen.
          </p>

          <p style={{ marginTop: '24px', color: '#6b7280' }}>
            Zuletzt aktualisiert: <strong>01.10.2025</strong>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Impressum;
